import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Container, OverviewCard } from "../../components";
import { generalIcons } from "../../utils/constants";
import RewardCalculator from "./RewardCalculator";
import { useStakingContext } from "../../context/staking-context";
import { getSingleDocument } from "../../utils/firebase.helper";
import useVanryData from "../../hooks/useVanryData";

function Calculator() {
  const {
    calculatorOverview,
    isFetchingCalculatorOverview,
    calculatorApy,
    overviewTooltipDetail,
    setCalculatorOverview,
    setIsFetchingCalculatorOverview
  } = useStakingContext();
  const navigate = useNavigate();

  const [isDataFetched, setIsDataFetched] = useState(false)
  const {vanryPrice, marketCap} = useVanryData({setIsDataFetched});

  const handleData = async () => {
    try {
      const data = await getSingleDocument("/vanar-dpos", 'data');
      const obj = {
        price: vanryPrice ?? 0,
        market_cap: marketCap ?? 0,
        total_staked: data?.total_staked,
        total_dPoS_validators: data?.total_validators,
        // active_validators_set: `${validatorDelgatorSummary?.active_validators < 10 ? "0" : ""}${validatorDelgatorSummary?.active_validators}/${validators?.length < 10 ? "0" : ""}${validators?.length}`,
      };
      setCalculatorOverview(obj);
      setIsFetchingCalculatorOverview(false);
    } catch (error) {

    }
  }

  useEffect(()=>{
    setIsFetchingCalculatorOverview(true);
    if(isDataFetched){
      handleData()
    }
  },[isDataFetched])

  return (
    <div className="relative h-auto pb-16 lg:pb-[100px]">
      <Container>
        <div className="flex items-center">
          <Link
            to={"/"}
            className="flex items-center -tracking-08 w-fit text-xs md:text-xsm font-medium text-dim"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 mr-4 *:w-full *:h-full">
              {generalIcons.backArrow}
            </div>
            <span className="opacity-[50%] mr-1">Overview / </span>{" "}
          </Link>
          <span className="text-xs md:text-xsm">Calculator</span>
        </div>

        <div className="relative mt-11">
          <div className="flex justify-between flex-col md:flex-row">
            <div>
              <div className="relative w-fit mx-auto md:mx-0">
                <h1 className="heading text-textcolor font-bold lg:-tracking-37 mb-3">
                  Vanar
                </h1>

                <span className="absolute block top-0 -right-14 laptop:-right-[90px] p-1 laptop:p-2 rounded-md bg-green/10 text-green text-xs laptop:text-[15px] leading-none font-semibold capitalize">
                  $VANRY
                </span>
              </div>
              <p className="text-sm md:text-base leading-6 md:leading-7 -tracking-1 font-normal text-dim/50 text-center md:text-left max-w-[651px] mx-auto laptop:mx-0 mb-5 md:mb-0">
                Vanar is an L1 blockchain crafted for real-world adoption,
                leveraging our expertise in games, entertainment, and brands.
              </p>
            </div>
            <div className="flex items-center justify-center gap-4 *:h-12 *:md:h-[58px] w-full md:w-fit *:w-full *:sm:w-[50%] *:md:w-fit">
              <Button
                className="primary-gradient text-[#06080C] !h-12 py-[10px] px-[18px] leading-none"
                onClick={() => navigate("/all-validator")}
              >
                Delegate
              </Button>
            </div>
          </div>

          <div className="mt-5 laptop:mt-10 grid gap-[9px] lg:gap-[13px] grid-cols-2 sm:grid-cols-3 laptop:grid-cols-4">
            {Object.entries(calculatorOverview).map(([key, value]) => (
              <div key={key} className="col-span-1">
                <OverviewCard
                  title={key}
                  value={value}
                  isFetching={isFetchingCalculatorOverview}
                  info={true}
                  overviewTooltipDetail={overviewTooltipDetail}
                />
              </div>
            ))}
          </div>
        </div>

        <RewardCalculator calculatorApy={calculatorApy} vanryPrice={vanryPrice} />
      </Container>
    </div>
  );
}

export default Calculator;
